import React, { useEffect, useState } from "react";
import { IoInformationCircleOutline } from "react-icons/io5";
import { ImSpinner2 } from "react-icons/im";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import DebounceInput from "../../../../../components/DebounceInput";
import { HiDotsHorizontal, HiOutlineShare } from "react-icons/hi";

import { copyToClipboard, classNames } from "../../../../../utils";
import Modal from "../../../../../components/modal";
import Loader from "../../../../../components/loader";

import Info from "./info";
import Raw from "./raw";

import api from "../../../../../services/api";

export default ({ epic, onClose, onDelete, framework = "default", project, setProject }) => {
  const [tab, setTab] = useState("info");
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState(null);

  useEffect(() => {
    setLoading(true);
    setValues(epic);
    setLoading(false);
  }, [epic]);


  console.log("values", values);

  if (!values) return <></>;

  return (
    <Modal isOpen={true} onClose={() => onClose(values)}>
      {loading ? (
        <Loader />
      ) : (
        <div className="w-full h-[90vh] bg-gray-100 overflow-y-scroll">
          <div className="bg-white flex flex-col w-full overflow-hidden">
            <div className="flex justify-between items-center gap-2 pt-2 px-2 mr-4">
              <div className="text-gray-600 text-lg">{`# ${values.index} `}</div>
              <DebounceInput
                debounce={800}
                className="input text-base font-semibold flex-1"
                placeholder="Title..."
                type="text"
                id="title"
                value={values.title || ""}
                onChange={async (e) => {
                  const { data } = await api.put(`/epic/${values._id}`, { title: e.target.value });
                  setValues(data);
                  toast.success("Title updated!");
                }}
              />
              <button
                className="transparent-btn"
                onClick={() => {
                  const url = new URL(window.location.href);
                  url.searchParams.set("t", values.title);
                  copyToClipboard(url.href);
                  toast.success("Copied to clipboard!");
                }}>
                <HiOutlineShare className="mr-1" />
                <span className="text-xs">Share</span>
              </button>
              <Menu epic={values} onDelete={onDelete} />
            </div>
            <nav className="flex flex-row w-full">
              <TabItem title="Info" tab="info" setTab={setTab} active={tab === "info"} Icon={IoInformationCircleOutline} />
              <TabItem title="Raw" tab="raw" setTab={setTab} active={tab === "raw"} />
              <div className="flex-1 border-b-2 border-gray-200"></div>
            </nav>
          </div>
          {tab === "info" && <Info epic={values} setEpic={setValues} framework={framework} project={project} setProject={setProject} />}
          {tab === "raw" && <Raw epic={values} />}
        </div>
      )}
    </Modal>
  );
};

const TabItem = ({ tab, title, setTab, active, Icon, Badge }) => (
  <button
    onClick={() => setTab(tab)}
    className={classNames(
      "group inline-flex items-center px-6 py-1 cursor-pointer text-sm font-medium border-b-2 transition-all duration-200",
      active ? "text-blue-600 border-blue-600 bg-white" : "text-gray-500 border-gray-200 hover:bg-gray-200",
    )}>
    {Icon ? (
      <Icon
        className={classNames(active ? "text-blue-600" : "text-gray-400 group-hover:text-gray-500", "-ml-0.5 mr-2 h-4 w-4 transition-colors duration-200")}
        aria-hidden="true"
      />
    ) : null}
    <div className="flex items-center gap-2">{title}</div>
    {Badge ? Badge : null}
  </button>
);

const Menu = ({ epic, onDelete }) => {
  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);

  const handleConvertTicket = async () => {
    try {
      setLoading(true);

      const obj = { name: epic.title, project_id: epic.project_id, project_name: epic.project_name };
      obj.comments = epic.comments;
      obj.epic_id = epic._id;
      obj.epic_name = epic.title;
      obj.epic_module = epic.module;

      const { data } = await api.post(`/notion`, obj);
      if (!data) return toast.error("Something went wrong!");

      const responseEpic = await api.put(`/epic/${epic._id}`, { sent_to_backlog_at: new Date() });
      if (!responseEpic.ok) return toast.error("Something went wrong!");

      toast.success("Epic converted as ticket!");
    } catch (e) {
      console.log(e);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  const handleDelete = async () => {
    try {
      if (!window.confirm("Are you sure you want to delete this epic?")) return;
      const { ok } = await api.remove(`/epic/${epic._id}`);
      if (!ok) return toast.error("Failed to delete epic");
      toast.success("Epic deleted successfully");
      onDelete?.();
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete epic");
    }
  };

  return (
    <div className="relative">
      <button className="transparent-btn" onClick={() => setOpen((p) => !p)}>
        <HiDotsHorizontal />
      </button>
      {open && (
        <div className="text-sm fixed right-2 top-[3rem] bg-white border border-gray-200 rounded-md shadow-md min-w-40 z-10">
          <button className="flex items-center gap-2 px-4 py-2 w-full hover:bg-gray-100" onClick={handleConvertTicket} disabled={loading}>
            <span>Move to backlog</span>
            {loading && <ImSpinner2 className="animate-spin" />}
          </button>
          <button className="flex items-center gap-2 px-4 py-2 w-full hover:bg-gray-100" onClick={handleDelete}>
            <span>Delete</span>
          </button>
        </div>
      )}
    </div>
  );
};
